import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from './core/Global';
import { UserService } from './core/user.service';

@Injectable()

export class CampusTypeService {
	public url: string = Global.url_seguros

	private _userService: UserService = inject(UserService)
	private _http = inject(HttpClient)

	getAll(): Observable<any> {
		return this._http.get(this.url + 'campus-types')
	}
	getByYear(year: any): Observable<any> {
		return this._http.get(this.url + 'campus-types/' + year)
	}

	getByGroup(group: any, year: any): Observable<any> {
		return this._http.get(this.url + 'campus-types/' + year + '/' + group)
	}
}
